import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.userView || initialState;

export const selectUserDetails = createSelector(
  [selectDomain],
  (state) => state.userDetails
);
